var _g, _path, _g2, _g3, _g4, _use, _use2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoccerWithQuestionMarks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    viewBox: "0 0 190 330",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m190 308c0 12.145-42.533 21.989-94.999 21.989s-95.001-9.844-95.001-21.989c0-12.144 42.534-21.99 95.001-21.99s94.999 9.845 94.999 21.99",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.371 306.17c-1.281 4.32-9.195 5.784-17.67 3.269-8.478-2.518-14.311-8.059-13.029-12.38 1.281-4.322 9.193-5.785 17.673-3.269 8.476 2.517 14.309 8.059 13.026 12.38",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.093 299.88s-2.768 10.176-10.874 8.686c-0 0-7.468-0.345-15.78-5.804-0-0 13.631 15.426 27.942 5.129-0 0 5.478-4.187-1.288-8.011",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.108 303.52c-6.138-1.422-11.348-1.573-11.634-0.337-0.286 1.237 4.46 3.392 10.598 4.811 6.137 1.42 11.348 1.573 11.635 0.336 0.288-1.236-4.459-3.391-10.599-4.81",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.418 260.81s-2.115 21.13-6.784 35.102c0-0 6.114 4.591 9.195 1.51 0-0 3.575-21.289 5.405-36.43-0-0-3.781-4.217-7.816-0.182",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m156.07 294.98c-0 13.556-10.989 24.545-24.543 24.545-13.555-0-24.543-10.989-24.543-24.545s10.988-24.543 24.543-24.543c13.554 0 24.543 10.988 24.543 24.543",
    fill: "#e6e6e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m156.07 294.98c-0 13.556-10.989 24.545-24.543 24.545-13.555-0-24.543-10.989-24.543-24.545s10.988-24.543 24.543-24.543c13.554 0 24.543 10.988 24.543 24.543z",
    fill: "none",
    stroke: "#ccc",
    strokeWidth: "1px"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m110.65 282.09h10.504l3.927 8.648-11.782 5.399-5.856-5.856 3.207-8.191z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.53 294.98v8.024l9.259 2.455 6.382-6.383-6.136-6.137-9.505 2.041z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.9 278.47 4.91 6.874 10.61-6.02-9.856-7.15-5.664-1.724v8.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.72 308.38-9.504-1.25-2.842 3.181s5.129 5.281 7.994 6.529l7.801 2.456v-5.413l-3.449-5.503z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#666",
    strokeWidth: "1px"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m124.72 308.38 6.819-5.369"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.3 296.14 1.909 10.992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.15 282.09 13.746-3.627"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m139.81 285.34 1.227 7.61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.53 294.98-6.449-4.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.18 299.08 8.83-2.313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.79 305.47 3.529 10.473"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140.44 317.86 2.844-5.012 6.006-0.922s-2.936 4.449-8.85 5.934"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.34 295.3c0-9.448 3.666-18.036 9.648-24.433-11.38 2.135-19.994 12.117-19.994 24.115 0 11.752 8.259 21.568 19.29 23.976-5.563-6.31-8.944-14.586-8.944-23.658",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m133.35 246.41c3.608 0.797 7.231-1.731 8.097-5.643s-1.354-7.735-4.963-8.534c-3.607-0.798-7.235 1.727-8.098 5.642-0.864 3.915 1.354 7.735 4.964 8.535",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m104.31 218.18s5.293-4.069 9.972-4.419c-0 0-12.127-18.168-28.496-20.282",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.38 245.27 8.268 0.112-10.844 22.02s-25.639 0.078-39.904-30.468c-0-0 36.607 8.257 42.48 8.336",
    fill: "#006837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.47 240.64s-9.406 15.362-10.759 26.228c-0-0 20.142-3.867 32.212 0.807 0-0-1.88-17.654 7.459-25.996 0 0-10.015-3.25-28.912-1.039",
    fill: "#006837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.039 200.77-16.168 0.497-0.441-14.373 16.169-0.495 0.44 14.371z",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.458 187.69 16.232 1.578 6e-3 0.221s-5.688 2.09-16.134 1.591z",
    fill: "#f7931e",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.44 132.56c0.934 30.432-21.506 55.811-50.121 56.689-28.616 0.879-52.568-23.081-53.502-53.511-0.934-30.431 21.508-55.814 50.123-56.691s52.568 23.08 53.5 53.513",
    fill: "#f7dec4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.2 139.78c0.172 5.637-4.257 10.352-9.899 10.525s-10.352-4.261-10.523-9.899c-0.17-5.638 4.258-10.35 9.897-10.522 5.641-0.173 10.352 4.257 10.525 9.896"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m100.55 136.88c0.071 2.272-1.718 4.167-3.99 4.237-2.272 0.071-4.176-1.714-4.245-3.984-0.069-2.271 1.716-4.174 3.993-4.243 2.271-0.069 4.172 1.715 4.242 3.99",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.93 141.04c0.089 2.921-2.278 5.367-5.287 5.458-3.008 0.092-5.523-2.203-5.613-5.123-0.089-2.919 2.278-5.366 5.288-5.458s5.521 2.2 5.612 5.123",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.36 123.63s-18.396-11.339-36.611-4.253c0 0 14.304-21.941 36.611 4.253",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.064 117.51s4.5-6.113 11.289-6.015c0 0-5.013 1.571-8.607 5.393 0 0-2.227 0.138-2.682 0.622",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m79.336 119.78s4.5-6.112 11.29-6.014c0 0-5.016 1.57-8.61 5.393 0 0-2.224 0.135-2.68 0.621",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m92.89 160.99c0.161 5.229-5.13 9.633-11.814 9.837-6.685 0.205-12.237-3.867-12.395-9.095-0.158-5.229 5.129-9.634 11.815-9.84s12.233 3.868 12.394 9.098",
    fill: "#f4c283"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.767 120.1s20.875-6.077 36.59 3.532c0 0-18.458-6.462-36.59-3.532",
    fill: "#f69220",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.677 184.96s-0.564-35.644 18.872-77.805l-17.504-10.049s-19.036 46.09-13.248 79.052z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.749 75.396c-80.132 2.458-67.211 101.72-67.211 101.72 14.017 12.068 31.262-0.959 31.262-0.959s-2.35-36.512 28.725-80.554",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.17 124.46s24.73-8.863 30.879-27.356c0 0 28.595 21.595 73.726 24.627-0 0 3.472-48.01-55.962-46.189 0 0-50.051 3.012-48.643 48.918",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.43 174.2s-14.025-59.35 40.724-94.609c0 0-42.102 41.863-33.212 94.377 0 0-1.581 5.337-7.512 0.232",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.116 119.64s-2.495 11.89-0.344 19.877c0 0 1.945-16.556 8.19-24.146",
    fill: "#42210b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.12 193.81c-2.346 1.077-5.391 1.479-8.593 0.949-3.161-0.526-5.88-1.864-7.75-3.608-13.527 4.554-15.809 26.808-18.683 44.114-0.149 0.91-0.26 1.791-0.351 2.659 8.976 3.611 8.453 2.986 19.177 4.767 10.015 1.662 19.755 2.256 28.868 1.903 0.225-0.973 0.432-1.974 0.605-3.022 2.88-17.356-2.236-39.185-13.273-47.762",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43.943 264.91s3.653-18.403 9.99-21.67l7.258-7e-3s-9.482 12.688-7.774 20.8z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.243 242.63s-40.18-22.713 5.908-32.265l5.679 3.196s-38.92 8.471-7.196 23.696c-0 0-1.145 4.462-2.768 4.918",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.781 238.68c-1.282 3.466 0.73 7.4 4.49 8.791s7.847-0.294 9.127-3.759-0.729-7.403-4.489-8.792-7.848 0.291-9.128 3.76",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.784 205.05s-8.363 22.016-8.739 33.895l-12.913-0.719-0.493-0.972s0.729-28.444 22.145-32.204",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.664 191.56s-21.737 11.766-25.551 15.821c0 0 10.854 11.507 17.284 13.266-0 0 11.562-9.363 14.406-19.525",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m49.302 207.39s18.138-12.532 23.316-14.401l2.997 2.102-21.467 17.687z",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.749 196.22s7.255 7.66 8.891 16.972l1.083-1.83s0.394-6.219-9.808-14.202",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.77 280.32c-1.195 4.346-9.075 5.968-17.601 3.626s-14.47-7.769-13.276-12.114c1.193-4.345 9.075-5.969 17.601-3.625 8.526 2.345 14.471 7.766 13.276 12.113",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147.36 274.07s-2.56 10.232-10.697 8.908c0 0-7.471-0.196-15.895-5.486-0 0 13.941 15.146 28.043 4.562 0 0 5.393-4.297-1.451-7.984",
    fill: "#fbb03b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m124.59 269.64s1.593 10.471 17.791 12.129c0 0-5.402 4.441-12.851-0.197-7.452-4.637-7.975-9.459-4.94-11.932",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.27 250.2s24.532-6.426 22.023 7.519-0.243 10.403-0.243 10.403l-7.228-0.325s7.87-17.93-17.406-11.801",
    fill: "#f9dec5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m121.29 173.26s-38.21-4.777-7.699 6.742l7.699-6.742z",
    fill: "#f05b26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m107.65 216.05s7.009 18.266 20.396 23.015c-0 0 6.558 1.736 6.558-1.291-0-0-20.96-18.142-22.605-23.576",
    fill: "#f9dec5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "g50976",
    transform: "matrix(.87623 0 0 .87623 10.829 3.0972)",
    fill: "#fbb03b",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m86.27 1.703c-11.153 1.7777-14.945 14.795-12.989 15.767 1.5273 0.75879 7.1055-8.2377 15.734-6.7387 5.7135 0.99262 5.6554 7.2005 1.7916 9.3541-3.5583 1.9832-5.5404 4.3083-5.6716 7.681-0.1142 2.9358 0.5903 7.4143 2.2548 7.3458 1.8479-0.07605-0.15714-5.721 6.4128-8.0735 5.469-1.8599 9.4917-5.3322 9.6145-11.52-0.11197-11.25-9.0012-15.113-17.146-13.815z",
    color: "#000000",
    style: {
      InkscapeStroke: "none"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87.628,
    cy: 46.01,
    r: 4.5985,
    strokeWidth: 9.3016,
    style: {
      paintOrder: "normal"
    }
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(28.03 88.348 141.47)",
    xlinkHref: "#g50976"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-30.421 84.764 133.68)",
    xlinkHref: "#g50976"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoccerWithQuestionMarks);
export default __webpack_public_path__ + "static/media/soccer-with-question-marks.ce432d84dc344f665e388523af6d9d6d.svg";
export { ForwardRef as ReactComponent };